<div class="tabs-row">

  <div class="navbar-left">
    <button class="logo-btn" (click)="changeSidebarVisible()">
      <img src="assets/favicon.ico" alt="MOLV">
    </button>
  </div>

  <div class="tabs-left">
    <molv-tabs
      [userTabs]="visibleTabs()"
      [activeTabId]="selectedMangaId()"
      (homeClicked)="goHome()"
      (tabSelected)="onTabSelected($event)"
      (tabClosed)="onTabClosed($event)">
    </molv-tabs>
  </div>

<div class="tabs-right">

  <button
    class="molv-btn molv-btn-pink upload-btn"
    [class.hidden]="viewMode !== ViewMod.Home"
    (click)="openUploadWindow()">

    <img src="assets/icons/molv-upload.svg" class="molv-upload-icon">

    <span class="desktop-text">
      {{ 'upload' | transloco }}
    </span>

  </button>

  @if (viewMode !== ViewMod.Single) {
    <button
      class="molv-btn molv-btn-pink"
      (click)="openSettingsWindow()">

      <img src="assets/icons/molv-settings.svg" class="molv-settings-icon">

    </button>
  }

</div>

</div>
